import CalendarTimelineView from './CalendarTimelineView';
import './CalendarTimelineView.scss';

export default CalendarTimelineView;
